export default __webpack_public_path__ + "static/media/spaceman.5ec7fcfa.png";